module.exports = __webpack_public_path__ + "img/water_50.2c7b492f.gif";